/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Lv_CisloInputs */

const cs_property_registry_lv_cislo = /** @type {(inputs: Property_Registry_Lv_CisloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo LV`)
};

const en_property_registry_lv_cislo = /** @type {(inputs: Property_Registry_Lv_CisloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LV number`)
};

/**
* | output |
* | --- |
* | "LV number" |
*
* @param {Property_Registry_Lv_CisloInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_cislo = /** @type {((inputs?: Property_Registry_Lv_CisloInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_CisloInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_cislo(inputs)
	return cs_property_registry_lv_cislo(inputs)
});